module.exports = __webpack_public_path__ + "img/nav-logo-one.16b38763.png";